<template>
  <div class="pv-24" style="padding-left: 160px; width: 100%;" :style="`background-color: ${backgroundColor}`">
    <new-webp-image-container
      src="bukareksa-logo-white.png"
      alt="bukareksa-logo"
      :is-ssr="isSSR"
      styles="width: 158px; height: 42px"
    />
  </div>
</template>

<script>
import NewWebpImageContainer from 'shared/components/NewWebpImageContainer';

export default {
  name: 'HeaderNavigation',
  components: {
    NewWebpImageContainer,
  },
  props: {
    backgroundColor: {
      type: String,
      default: '#093832',
    },
  },
  computed: {
    isSSR() {
      return this.$root.isSSR;
    },
  },
};
</script>
